/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelhistorytitle2Inputs */

const en_channelhistorytitle2 = /** @type {(inputs: Channelhistorytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent messages`)
};

const de_channelhistorytitle2 = /** @type {(inputs: Channelhistorytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesendete Nachrichten`)
};

/**
* | output |
* | --- |
* | "Sent messages" |
*
* @param {Channelhistorytitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelhistorytitle2 = /** @type {((inputs?: Channelhistorytitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelhistorytitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelhistorytitle2(inputs)
	return de_channelhistorytitle2(inputs)
});
export { channelhistorytitle2 as "channelHistoryTitle" }